import { render, staticRenderFns } from "./AmountCurrent.vue?vue&type=template&id=c2fcf40c"
import script from "./AmountCurrent.vue?vue&type=script&lang=js"
export * from "./AmountCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports